import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'frozenWater',
      d: 'M0,-1.5h2.5v0.5h-2.5zM2,-1h1.5v0.5h-1.5zM3,-0.5h0.5v1h-0.5zM-3.5,0h1v0.5h-1zM-3,0.5h2v0.5h-2zM-2,1h4.5v0.5h-4.5z',
    },
    {
      paint: 'ice',
      d: 'M-2,-1h4v0.5h-4zM-3,-0.5h2v0.5h-2zM0.5,-0.5h2.5v0.5h-2.5zM-2.5,0h5.5v0.5h-5.5zM-1,0.5h3v0.5h-3z',
    },
    {
      paint: 'snowCap',
      d: 'M-1.5,-2h2v0.5h-2zM-3,-1.5h3v0.5h-3zM-3.5,-1h1.5v0.5h-1.5zM-3.5,-0.5h0.5v0.5h-0.5zM2,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'icicleBlue', d: 'M-1,-0.5h1.5v0.5h-1.5z' },
  ],
  pixels: 79,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'frozenWater',
      d: 'M2,-1h1v0.5h-1zM3,-0.5h0.5v1h-0.5zM-3.5,0h1v0.5h-1zM-3,0.5h2v0.5h-2zM-3,1h6v0.5h-6zM0.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M0.5,-1.5h0.5v0.5h-0.5zM-2,-1h4v0.5h-4zM-3,-0.5h2v0.5h-2zM0.5,-0.5h2.5v0.5h-2.5zM-2.5,0h5.5v0.5h-5.5zM-1,0.5h3v0.5h-3z',
    },
    {
      paint: 'snowCap',
      d: 'M-1.5,-2h2v0.5h-2zM-3,-1.5h3.5v0.5h-3.5zM-3.5,-1h1.5v0.5h-1.5zM-3.5,-0.5h0.5v0.5h-0.5zM2,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'icicleBlue', d: 'M-1,-0.5h1.5v0.5h-1.5z' },
  ],
  pixels: 79,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'frozenWater',
      d: 'M0.5,-1.5h1.5v0.5h-1.5zM2,-1h1v0.5h-1zM-1,-0.5h0.5v0.5h-0.5zM0.5,-0.5h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM-3,0h0.5v0.5h-0.5zM-1.5,0h3.5v0.5h-3.5zM-3,0.5h2.5v0.5h-2.5zM-2,1h4v0.5h-4z',
    },
    {
      paint: 'ice',
      d: 'M-2,-1h4v0.5h-4zM-3,-0.5h2v0.5h-2zM1.5,-0.5h1.5v0.5h-1.5zM-2.5,0h1v0.5h-1zM2,0h1v0.5h-1zM-0.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-1.5,-2h2v0.5h-2zM-3,-1.5h3.5v0.5h-3.5zM-3.5,-1h1.5v0.5h-1.5zM-3.5,-0.5h0.5v0.5h-0.5zM3,0h0.5v0.5h-0.5zM2,0.5h1.5v0.5h-1.5zM2,1h0.5v0.5h-0.5z',
    },
    { paint: 'icicle', d: 'M-0.5,-0.5h1v0.5h-1z' },
  ],
  pixels: 76,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
